"use client";

import { useMemo } from "react";
import { useTable } from "spacetimedb/react";
import { tables } from "@/module_bindings";
import { mapApiKey } from "@/lib/stdb-map";
import { useResolvedCurrentOrganization } from "./use-current-organization";
import type { ApiKey } from "@/types/api-keys";

export function useApiKeys(orgId?: string): {
  apiKeys: ApiKey[];
  isReady: boolean;
} {
  const current = useResolvedCurrentOrganization();
  const effectiveOrgId = orgId ?? current.organization?.id;

  const [rows, keysReady] = useTable(tables.org_api_keys);

  const apiKeys = useMemo(() => {
    if (!effectiveOrgId) return [];
    return rows
      .filter((row) => row.organizationId === effectiveOrgId)
      .map(mapApiKey);
  }, [rows, effectiveOrgId]);

  const isReady = orgId ? keysReady : keysReady && current.isReady;

  return { apiKeys, isReady };
}
